import "babel-polyfill";

import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

import global from './Global.vue';
import utils from './Utils.vue';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;

Vue.use(ElementUI);

Vue.prototype.$http = axios;
Vue.prototype.$utils = utils;
Vue.prototype.$global = global;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
});

// 添加登录判断
router.beforeEach((to, from, next) => {
  window.document.title = "喔小窝"
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
    if (utils.isLogin()) {  // 通过vuex state获取当前的token是否存在
      next();
    } else {
      // router.replace("/login")
      next({
        path: '/login',
        query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    next();
  }
});



// WEBPACK FOOTER //
// ./src/main.js